import { useState } from 'react';
import { Link } from 'react-router-dom';
import useOnclickOutside from 'react-cool-onclickoutside';

import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import analysisIcon from '../../../assets/images/Icons/analysis.png';
import dashboardIcon from '../../../assets/images/Icons/business-report.png';
import importIcon from '../../../assets/images/Icons/import.png';
import reportIcon from '../../../assets/images/Icons/report.png';
import browserIcon from '../../../assets/images/Icons/browser.png';
import bugIcon from '../../../assets/images/Icons/bugtracking.png';
import realTimeIcon from '../../../assets/images/Icons/realTime.png';

import { Drawer, DrawerHeader } from './SideDrawer.styles';

const CustomLink = ({ children, to, ...props }) => {
  return (
    <div style={{ backgroundColor: 'white' }} {...props}>
      <Link style={{ textDecoration: 'none', color: '#222222' }} to={to}>
        {children}
      </Link>
    </div>
  );
};

const SideDrawer = () => {
  const [open, setOpen] = useState(false);

  const ref = useOnclickOutside(() => {
    setOpen(false);
  });

  return (
    <Drawer variant="permanent" open={open} ref={ref}>
      <DrawerHeader open={open}>
        <IconButton color="inherit" aria-label="open drawer" onClick={() => setOpen(!open)}>
          {open ? <ChevronLeftIcon /> : <ChevronRightIcon />}
        </IconButton>
      </DrawerHeader>
      <Divider />
      <List>
        {/* <CustomLink to="dashboard"> */}
        {/* <CustomLink to="">
          <ListItem button key={'Dashboard'}>
            <ListItemIcon>
              <img src={dashboardIcon} alt="Dashboard" />
            </ListItemIcon>
            <ListItemText primary={'Dashboard'} />
          </ListItem>
        </CustomLink> */}
        <CustomLink to="">
          <ListItem button key={'Record browser'}>
            <ListItemIcon>
              <img src={browserIcon} alt="Browser" />
            </ListItemIcon>
            <ListItemText primary={'Record browser'} />
          </ListItem>
        </CustomLink>
        {/* <CustomLink to="items-list">
          <ListItem button key={'Analytics'}>
            <ListItemIcon>
              <img src={analysisIcon} alt="Analytics" />
            </ListItemIcon>
            <ListItemText primary={'Analytics'} />
          </ListItem>
        </CustomLink> */}
        {/* <CustomLink to="">
          <ListItem button key={'Reports'}>
            <ListItemIcon>
              <img src={reportIcon} alt="Reports" />
            </ListItemIcon>
            <ListItemText primary={'Reports'} />
          </ListItem>
        </CustomLink> */}
        <CustomLink to="importview">
          <ListItem button key={'Import records'}>
            <ListItemIcon>
              <img src={importIcon} alt="Import" />
            </ListItemIcon>
            <ListItemText primary={'Import records'} />
          </ListItem>
        </CustomLink>
        {/* <CustomLink to="">
          <ListItem button key={'Bugtracking'}>
            <ListItemIcon>
              <img src={bugIcon} alt="Bugtracking" />
            </ListItemIcon>
            <ListItemText primary={'Bugtracking'} />
          </ListItem>
        </CustomLink>
        <CustomLink to="">
          <ListItem button key={'Real time preview'}>
            <ListItemIcon>
              <img src={realTimeIcon} alt="Real time preview" />
            </ListItemIcon>
            <ListItemText primary={'Real time preview'} />
          </ListItem>
        </CustomLink> */}
      </List>
    </Drawer>
  );
};

export default SideDrawer;
